<template>
    <div class="header-holder">
        <img class="logo" src="/logo.svg" />
        <h1 class="game-title" v-text="title"></h1>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: 'games.nozkok.com',
        },
    },
};
</script>

<style scoped>
.header-holder {
    width: 100%;
    height: 48px;
    background-color: #0065a0;
    line-height: 48px;
}

.logo {
    height: 37px;
    margin-left: 20px;
    margin-right: 20px;
}

h1.game-title {
    line-height: 48px;
    display: inline;
}
</style>
